// src/lib/email.js
import emailjs from "@emailjs/browser";

emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);

export function sendSignupEmail({ name, email, source }) {
  const params = {
    name,
    email,
    source,
    created_at: new Date().toISOString(),
  };
  return emailjs.send(
    process.env.REACT_APP_EMAILJS_SERVICE_ID,
    process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
    params
  );
}
